// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__1dbWA","collaborators":"styles_collaborators__W5MXW"};